export let EditorHost = /*#__PURE__*/function (EditorHost) {
  EditorHost["editor"] = "classic-editor";
  EditorHost["studio"] = "studio";
  EditorHost["odeditor"] = "odeditor";
  return EditorHost;
}({});
//# sourceMappingURL=types.js.map